/* Casual copy deterrent on product artwork.

   Be clear about what this is: it stops a right-click and a drag-to-desktop.
   It does NOT stop anyone determined -- view source, dev tools, the direct CDN
   URL and a screenshot all still work, and they always will, because a browser
   cannot display an image it has not already downloaded.

   The real protection for a print shop is resolution, not scripting: the
   masters on this store are around 832x1248, which is fine on screen and far
   too small to print at 16x20 or 24x30. Someone can take the picture; they
   cannot print it.

   Scoped to product and collection artwork only. The wall tool is left alone --
   customers are meant to save that one.

   To switch this off: delete the cb-guard line from snippets/cb-scripts.liquid. */
(function(){
  'use strict';

  var SEL='.card__media img, .product__media img, .grid__item img, .wp-tile-img img, .cb-rv__photo';

  function inWallTool(el){
    return !!(el.closest && el.closest('[data-modal], .wp-stage, [data-stage]'));
  }

  function guard(e){
    var t=e.target;
    if(!t||t.tagName!=='IMG')return;
    if(!t.matches||!t.matches(SEL))return;
    if(inWallTool(t))return;
    e.preventDefault();
  }

  document.addEventListener('contextmenu',guard);
  document.addEventListener('dragstart',guard);

  var s=document.createElement('style');
  s.textContent=SEL.split(',').map(function(x){return x.trim();}).join(',')+
    '{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-user-drag:none}';
  document.head.appendChild(s);
})();
